import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

import { UtilityService } from '../../../core/services/utility.service';
import { PerformanceService } from '../../../pages/performance/services/performance.service';

@Component({
  selector: 'app-view-edit-reviewer-modal',
  templateUrl: './view-edit-reviewer-modal.component.html',
  styleUrls: ['./view-edit-reviewer-modal.component.css'],
})
export class ViewEditReviewerModalComponent implements OnInit {
  @Input() data: any;
  format: string;
  formData: { [key: string]: any } = {};
  reviewerAddList: any[] = [];
  exist = false;
  reviewerList: any[] = [];
  lastSave: { [key: string]: any } = {};
  unsubmit = false;

  constructor(
    public activeModal: NgbActiveModal,
    private utilityService: UtilityService,
    private performanceService: PerformanceService
  ) {
    this.format = this.utilityService.getDateFormat().toUpperCase();
  }

  ngOnInit(): void {
    this.getReviewerList();
    this.getAttendees();
  }

  getAttendees() {
    this.performanceService.getAttendees().then((response: any) => {
      if (response != null) {
        this.reviewerAddList = response;
        this.reviewerAddList.forEach((key: any, value: any) => {
          if (value != null && value.KeyID == this.data.UserKeyID) {
            this.reviewerAddList.splice(key, 1);
          }
        });
      }
    });
  }

  checkExisting() {
    this.exist = false;
    this.reviewerList.forEach((val: any) => {
      if (this.formData.selectedReviewer == val.UserKeyID) {
        this.exist = true;
      }
    });
  }

  getReviewerList() {
    this.performanceService.getReviewersByInstance(this.data.PerformanceInstanceID).then((response: any) => {
      if (response != null) {
        this.reviewerList = response;
        this.reviewerList.forEach((value: any) => {
          if (value.DateSubmitted != null) {
            value.DateSubmittedDisplay = moment(value.DateSubmitted).utc().format(this.format);
          }
        });
      }
    });
  }

  addNewReviewer() {
    this.performanceService.reviewerAdd(this.data.PerformanceInstanceID, this.formData.selectedReviewer).then((response: any) => {
      if (response != null) {
        this.fadeLabel(response.success);
        if (response.success) {
          this.formData.selectedReviewer = null;
          this.getReviewerList();
        }
      }
    });
  }

  unsubmitReviewer(rowData: any) {
    this.performanceService.unsubmitReview(rowData.PerformanceInstanceID, rowData.PerformanceReviewerID).then((response: any) => {
      if (response != null) {
        this.fadeLabel(true);
        this.getReviewerList();
        this.unsubmit = true;
      }
    });
  }

  removeReviewer(rowData: any) {
    this.performanceService.reviewerDelete(rowData.PerformanceInstanceID, rowData.PerformanceReviewerID).then((response: any) => {
      if (response != null) {
        this.fadeLabel(response.success);
        if (response.success) {
          this.reviewerList.forEach((val: any, key: any) => {
            if (val.UserKeyID == rowData.UserKeyID) {
              this.reviewerList.splice(key, 1);
            }
          });
          if (this.formData.selectedReviewer != null) {
            this.checkExisting();
          }
        }
      }
    });
  }

  closeClicked() {
    this.activeModal.close(this.unsubmit);
  }

  fadeLabel(status: any) {
    this.formData.labelFade = false;
    this.lastSave = this.utilityService.fadeLabel(status);
    setTimeout(() => {
      this.formData.labelFade = true;
    }, 2000);
  }
}
